import { MenuItem, TextField, Checkbox, ListItemText } from '@mui/material';
import { useState } from 'react';
import { CheckCircle, Close } from '@mui/icons-material';
import CustomEditor from '../utils/CustomEditor';
import './PostTalentPage.scss'
import ImageUpload from '../utils/ImageUpload';
import Samples from '../utils/Samples';
import CustomSelect from '../utils/customSelect';
import CustomTextField from '../utils/CustomTextField';


function PostTalentTemplate({setter}) {
    const [talentType, setTalentType] = useState(undefined);
    const [categories, setCategories] = useState([]);
    const [title, setTitle] = useState('');
    const [titleChars, setTitleChars] = useState('');
    const [price] = useState();
    const [currency, setCurrency] = useState();
    const [duration] = useState();
    const [location, setLocation] = useState();
    const [language, setLanguage] = useState([]);
    const [durationType, setDurationType] = useState();

    const talentCategories = [
        'Proof Reading',
        'Content writing',
        'Copy Pasting'
    ];
    const subCategories = [
        'Book Editing',
        'Article Editing',
        'Rewriting & Revisions',
        'Technical Editing',
        'Article Editing',
        'Book Editing',
        'Book Editing',
        'Book Editing',
        'Book Editing',
    ];

    const currencies = [
        {
            symbol: '₹',
            name: 'Rupees'
        },
        {
            symbol: '$',
            name: 'Dollars'
        },
        {
            symbol: '€',
            name: 'Euro'
        },
        {
            symbol: '¥',
            name: 'Yen'
        },
        {
            symbol: '£',
            name: 'Pounds'
        }
    ];

    const languages = ['Tamil', 'Hindi', 'English', 'French', 'Sanskrit'];
    const locations = ['Bangalore', 'Chennai', 'Hyderabad', 'Mumbai', 'Kolkata'];

    const durationTypes = [
        'Days',
        'Weeks',
        'Months'
    ]

    const handleCategoriesChange = (e, v) => {
        setCategories(e.target.value);
    }

    const handleCurrencyChange = (e, v) => {
        setCurrency(e.target.value);
    }

    const handleDurationTypeChange = (e, v) => {
        setDurationType(e.target.value);
    }

    const handleLocationChange = (e, v) => {
        setLocation(e.target.value);
    }

    const handleLanguageChange = (e, v) => {
        setLanguage(e.target.value);
    }

    const handleTalentTypeChange = (e,v) => {
        setter && setter(e.target.value);
        setTalentType(e.target.value);
    }

    const handletitleChange = (e, v) => {
        setTitle(e.target.value);
        setTitleChars(e.target.value.length > 0 ? e.target.value.length : undefined);
    }

    const titleSample = {
        link: 'See more title by others',
        title: 'Titles Posted By Other Users',
        warnings: ['Do not copy this, Write your own Title for your Talent.'],
        samples: [
            'I Will Proofread Your Content And Edit Them To Make Them Flawless For The Readers.',
            'I Will Edit Upto 1000 Words In 24 Hours For You',
            'I Will Edit All Your Content And Make It Easier To Read',
            'I Will Proofread Your Content And Edit Them To Make Them Flawless To Readers.',
            'I Have An Excellence Knowledge Of Grammatical Erros And Spellings.',
            'I Can Edit 5000 Words Per Day On Various Topics Just For Rs. 2700.',
            'I Will Edit All Your Given Words To Make It Easier For You To Read.',
            'I Will Edit 1000 Words Per Day For Those Who Need',
            'I Can Edit Upto 20 Assignments A Day Only For Rs.200/- Each',
            'Quick And Clean Proofreading And Editing For A Reasonable Price'
        ]
    };

    const talentSample = {
        link: 'See Talent Posted By Other Users',
        title: 'Talents Posted on this Category',
        warnings: ['Do not copy other Talents.', 'By copying other\'s talents, your posted talents will be deleted.'],
        samples: [
            'About my work: I will proofread any web content and edit them to make them flawless for the readers. Besides this, I have a team specialized for editing your document? Every writer wants to make their piece of writing the best one and rank it on the search',
            'Why should you choose me for editing your document? Every writer wants to make their piece of writing the best one and rank it on the search engines for editing your document? Every writer wants to make their piece of writing the best one and rank it on the search',
            'About my work: I will proofread any web content and edit them to make them flawless for the readers. Besides this, I have a team specialized for editing your document? Every writer wants to make their piece of writing the best one and rank it on the search',
            'Why should you choose me for editing your document? Every writer wants to make their piece of writing the best one and rank it on the search engines for editing your document? Every writer wants to make their piece of writing the best one and rank it on the search',
            'About my work: I will proofread any web content and edit them to make them flawless for the readers. Besides this, I have a team specialized for editing your document? Every writer wants to make their piece of writing the best one and rank it on the search',
            'Why should you choose me for editing your document? Every writer wants to make their piece of writing the best one and rank it on the search engines for editing your document? Every writer wants to make their piece of writing the best one and rank it on the search',
            'About my work: I will proofread any web content and edit them to make them flawless for the readers. Besides this, I have a team specialized for editing your document? Every writer wants to make their piece of writing the best one and rank it on the search'
        ]
    };

    return (
        <div className="post-talent-template-wrp">
            <div className='desc-wrp'>
                <div className='desc-title'>Post Your Talents</div>
                <div className='description'>Simply post your talent - What work you can do on your parttime/fulltime at what price you can do that.</div>
            </div>
            <div className='talent-info-wrp'>
                <form>
                    <div className='categories-input-wrp'>
                        <label>Talent Type</label>
                        <CustomSelect value={talentType} onChange={handleTalentTypeChange} 
                        options={talentCategories} />
                    </div>
                    { talentType && <div className='categories-input-wrp'>
                        <label>{talentType} Categories</label>
                        <CustomSelect value={categories} onChange={handleCategoriesChange} 
                            renderValue={(selected) => 'Select Sub Categories'}
                        options={subCategories} multiple outerSelection />
                    </div> }
                    <div className='title-input-container'>
                        <label>Title</label>
                        <div className='title-input'>
                            <CustomTextField name='title-input' className='rw-url' placeholder='Title' value={title} inputProps={{ maxLength: 100 }} onChange={handletitleChange} />
                        </div>
                        <Samples data={titleSample} />
                    </div>
                    <div className='title-input-container'>
                        <label>Description</label>
                        <div className='desc'>Simply describe your talent with some introduction, Experience, your past Projects and Clients, etc</div>
                        <Samples data={talentSample} />
                        <CustomEditor></CustomEditor>
                    </div>
                    <div className='inputs-wrp'>
                        <div className='input-wrp'>
                            <label>Price</label>
                            <TextField className="input-primary" type={'number'} fullWidth placeholder="Price" value={price} InputLabelProps={{ shrink: false }} onChange={handletitleChange} />
                            <CustomSelect value={currency} defaultValue={currencies[0]}
                                onChange={handleCurrencyChange} options={currencies}
                                className='input-secondary'
                                renderValue={(selected) => selected.symbol}
                                renderOptions={(c, i) => <MenuItem key={i} value={c}>{c.symbol} - {c.name}</MenuItem>}
                            />
                        </div>
                        <div className='duration-input input-wrp'>
                            <label>Duration</label>
                            <TextField className="input-primary" type={'number'} fullWidth placeholder="Duration" value={duration} InputLabelProps={{ shrink: false }} onChange={handletitleChange} />
                            <CustomSelect value={durationType} defaultValue={durationTypes[0]}
                                onChange={handleDurationTypeChange} options={durationTypes} className='input-secondary' />
                        </div>
                    </div>
                    <div className='inputs-wrp'>
                        <div className='input-wrp'>
                            <label>Languages Known</label>
                            <CustomSelect
                                multiple
                                value={language}
                                onChange={handleLanguageChange}
                                options={languages}
                                renderOptions={(c, i) =>
                                    <MenuItem key={i} value={c}>
                                        <Checkbox checked={language.indexOf(c) > -1} />
                                        <ListItemText primary={c} />
                                    </MenuItem>}
                            />
                        </div>
                        <div className='input-wrp'>
                            <label>Location</label>
                            <CustomSelect value={location} onChange={handleLocationChange} options={locations} />
                        </div>
                    </div>
                    <div className='inputs-wrp'>
                        <div className='images-input-wrp'>
                            <ImageUpload inputProps={{name: 'Upload Your Works', label: '(Extension Jpg, Png, Jpeg)'}}
                                renderPreview={(p, i, close) => <div key={i} className='works-wrp'>
                                    <div className='file-name-wrp'>
                                        <span>{p.file.name}</span>
                                        <Close onClick={close}></Close>
                                    </div>
                                    <img src={p.url} alt='work-preview' />
                                    <div className='set-as-featured'>
                                        <p>Set As Featured Image</p>
                                        <Checkbox icon={<div className='unchecked'></div>}
                                            checkedIcon={<CheckCircle />}></Checkbox>
                                    </div>
                                </div>
                                }
                            />
                        </div>
                    </div>
                    <button className="submit-form" type='submit'> Post Talent</button>
                </form>
            </div>
        </div>
    );
};
export default PostTalentTemplate;